import DOMPurify from "dompurify";

// Admins paste announcements straight from WhatsApp, so plain URLs become
// links and *text* becomes bold. Only text outside existing links is touched.
const URL_PATTERN = /(https?:\/\/[^\s<]+[^\s<.,;:!?)"'])/g;
const BOLD_PATTERN = /\*([^*\n]+)\*/g;

const toInlineHtml = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(BOLD_PATTERN, "<strong>$1</strong>")
    .replace(URL_PATTERN, '<a href="$1">$1</a>');

const formatTextNodes = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes
    .filter((node) => !node.parentElement.closest("a"))
    .forEach((node) => {
      const html = toInlineHtml(node.textContent);
      if (html === node.textContent) return;
      const holder = document.createElement("span");
      holder.innerHTML = html;
      node.replaceWith(...holder.childNodes);
    });
};

// Every link opens in a new tab.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

const formatAnnouncement = (html) => {
  const root = document.createElement("div");
  root.innerHTML = DOMPurify.sanitize(html);
  formatTextNodes(root);
  return DOMPurify.sanitize(root.innerHTML, { ADD_ATTR: ["target"] });
};

export default formatAnnouncement;
